'use client'
import { type FC } from 'react'
import { HStack, List, ListItem, Stack } from '@chakra-ui/react'
import { type CategoryDTO } from 'ecosystem'
import { sortCategories } from 'shared-utils'
import { usePathname } from 'next/navigation'
import { GrandHeading, GrandNextLink } from 'ui/common'

interface ICategoryWithSubCategoriesProps {
  category: CategoryDTO
  paths: {
    categories: string
  }
}

const CategoryWithSubCategories: FC<ICategoryWithSubCategoriesProps> = ({ category, paths }) => {
  const pathname = usePathname()
  const subcategories = category.subCategories
    ? sortCategories([...category.subCategories]).splice(0, 5)
    : []

  const fullPath = `${paths.categories}/${category.slug}`

  return (
    <Stack spacing={2}>
      <HStack align="flex-start" spacing={1}>
        <List spacing={1}>
          <ListItem color="text.mild" fontSize="sm">
            <GrandNextLink aria-label={category.name} href={fullPath}>
              <GrandHeading
                cursor="inherit"
                fontSize="sm"
                title={category.name}
                {...(pathname?.includes(fullPath) && {
                  color: 'primary',
                  _hover: {
                    color: 'text.default'
                  }
                })}
                {...(pathname === fullPath && { fontWeight: 'bold' })}
              />
            </GrandNextLink>
          </ListItem>
          {subcategories.map((subCategory) => {
            const subCategoryFullPath = `${paths.categories}/${subCategory.slug}`

            return (
              <ListItem
                _hover={{
                  color: 'text.default'
                }}
                color="text.mild"
                cursor="pointer"
                fontSize="sm"
                key={subCategory.id}
                {...(pathname === subCategoryFullPath && {
                  color: 'primary',
                  fontWeight: 'bold'
                })}
              >
                <GrandNextLink aria-label={subCategory.name} href={subCategoryFullPath}>
                  {subCategory.name}
                </GrandNextLink>
              </ListItem>
            )
          })}
        </List>
      </HStack>
    </Stack>
  )
}

export default CategoryWithSubCategories
